import React, { useEffect } from "react";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { LogoStrip } from "@/components/site/LogoStrip";
import { Leistungen } from "@/components/site/Leistungen";
import { Kpis } from "@/components/site/Kpis";
import { Referenzen } from "@/components/site/Referenzen";
import { Ausgangslage } from "@/components/site/Ausgangslage";
import { About } from "@/components/site/About";
import { Ansprechpartner } from "@/components/site/Ansprechpartner";
import { Partner } from "@/components/site/Partner";
import { Methode } from "@/components/site/Methode";
import { Ablauf } from "@/components/site/Ablauf";
import { Faq } from "@/components/site/Faq";
import { Kontakt } from "@/components/site/Kontakt";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (!el) return;
      e.preventDefault();
      const top = el.getBoundingClientRect().top + window.scrollY - 76;
      window.scrollTo({ top, behavior: "smooth" });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <LogoStrip />
        <Leistungen excludeHref="/machbarkeitsstudien/" />
        <Kpis />
        <Referenzen />
        <Ausgangslage />
        <About />
        <Ansprechpartner />
        <Partner />
        <Methode />
        <Ablauf />
        <Faq />
        <Kontakt />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </>
  );
}
